import type { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import type { TranslationController } from '@adornis/translation-core/client/translation-controller.js';
import { nothing } from 'lit';
import type { BHTranslationDictionary } from '../../translations/translation.js';
import type { InvoiceUserInvoiceTablePlugin } from '../plugin-types.js';

export const defaultInvoiceUserInvoicesTablePlugin: InvoiceUserInvoiceTablePlugin = {
  id: 'invoice-user-invoice-table::default',
  type: 'invoice-user-invoice-table',
  render: (
    host: ChemistryLitElement,
    translation: TranslationController<BHTranslationDictionary>,
    userID: string,
    institutionID: string,
  ) => nothing,
};
